'use client';

import { createContext, useContext } from 'react';
import { FieldError, UseFormRegister, RegisterOptions, Control } from 'react-hook-form';

// Simplified context with essential props only
interface FormFieldContextValue {
  name: string;
  fieldId: string;
  errorId: string;
  error?: FieldError;
  register?: UseFormRegister<any>;
  control?: Control<any>;
  disabled?: boolean;
  validation?: RegisterOptions<any>;
  required?: boolean;
  isDirty?: boolean;
  isValid?: boolean;
}

const FormFieldContext = createContext<FormFieldContextValue | null>(null);

export const useFormFieldContext = () => {
  const context = useContext(FormFieldContext);
  if (!context) {
    throw new Error('FormField compound components must be used within a FormField');
  }
  return context;
};

export { FormFieldContext };
export type { FormFieldContextValue };
